export default __webpack_public_path__ + "static/media/icon-check.574709ca.svg";